<ng-container *ngIf="initialized">
  <router-outlet></router-outlet>
  <app-footer *ngIf="showFooter()"></app-footer>
</ng-container>
